namespace advisorop.services {
    `use strict`;

    export class AdvisoryFirmApi {

        readonly apiUrl = `/api/advisoryfirm`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        getById(id: number): ng.IHttpPromise<domains.IAdvisoryFirm> {
            return this.$http.get(`${this.apiUrl}/${id}`);
        }

        getAdvisoryFirms(): ng.IHttpPromise<domains.IAdvisoryFirm[]> {
            return this.$http.get(`${this.apiUrl}`);
        }

        getAdvisoryFirmsLight(): ng.IHttpPromise<Array<domains.IAdvisoryFirm>> {
            return this.$http.get("api/servicer/getadvisoryfirmslight");
        }

        getAdvisoryLeadsForCompanyGroupServicer(companyGroupId: number): ng.IHttpPromise<Array<domains.IAdvisor>> {
            return this.$http.get("api/servicer/getadvisoryleadsforcompanygroupservicer/" + companyGroupId);
        }

        getAdvisoryFirmsByCompanyGroup(companyGroupId: number): ng.IHttpPromise<Array<domains.IAdvisoryFirm>> {
            return this.$http.get("api/servicer/getadvisoryfirmsbycompanygroup/" + companyGroupId);
        }

        searchByName(searchTerm: string, companyGroupId: number): ng.IHttpPromise<{}> {
            return this.$http.get("/api/servicer/searchadvisoryfirmbyname/" + searchTerm + "/" + companyGroupId);
        }

        create(advisoryFirm: domains.IAdvisoryFirm): ng.IHttpPromise<domains.IAdvisoryFirm> {
            return this.$http.post("/api/servicer/createadvisoryfirm", advisoryFirm);
        }

        update(advisoryFirm: domains.IAdvisoryFirm): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/updateadvisoryfirm", advisoryFirm);
        }

        getTamps(advisoryFirmId: number): ng.IHttpPromise<domains.ITamp[]> {
            return this.$http.get(`${this.apiUrl}/${advisoryFirmId}/tamps`);
        }

        getProducts(advisoryFirmId: number, tampId: number): ng.IHttpPromise<domains.IAdvisoryFirmProduct[]> {
            return this.$http.get(`${this.apiUrl}/${advisoryFirmId}/products?tampId=${tampId}`);
        }

        syncOrionModels(advisoryFirmId: number): ng.IHttpPromise<{}> {
            return this.$http.post(`${this.apiUrl}/${advisoryFirmId}/syncorionmodels`, {});
        }

        getProductTypes(advisoryFirmId: number): ng.IHttpPromise<domains.IAdvisoryFirmProductType[]> {
            return this.$http.get(`${this.apiUrl}/${advisoryFirmId}/producttypes`);
        }

        getManagers(advisoryFirmId: number): ng.IHttpPromise<domains.IAdvisoryFirmManager[]> {
            return this.$http.get(`${this.apiUrl}/${advisoryFirmId}/managers`);
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("advisoryFirmApi", AdvisoryFirmApi);
}